export default {
	taqyimee: {
		en: "Taqyimee",
		ar: "تقييمي",
	},
	new_update: {
		en: "New Update Available",
		ar: "تحديث جديد متاح",
	},
	critical_update: {
		en: "This update is mandatory. please update to continue",
		ar: "هذا التحديث إلزامي. يرجى التحديث للمتابعة",
	},
	no_data_available: {
		en: "No data available",
		ar: "لا توجد بيانات",
	},
	evaluation_companies: {
		en: "Valuation Companies",
		ar: "شركات التقييم",
	},
	search_evaluation_company: {
		en: "Search for Valuation company",
		ar: "ابحث عن شركة تقييم",
	},
	req_evaluation: {
		en: "Valuation Request",
		ar: "طلب تقييم",
	},
	contact_details: {
		en: "Contact Details",
		ar: "معلومات التواصل",
	},
	choose_role: {
		en: "Choose Role",
		ar: "اختر الدور",
	},
	owner: {
		en: "Owner",
		ar: "المالك",
	},
	owner_tenant: {
		en: "Owner / Tenant",
		ar: "المالك / المستأجر",
	},
	owner_rep: {
		en: "Owner Representative",
		ar: "ممثل المالك",
	},
	evaluator: {
		en: "Valuator",
		ar: "مقيم",
	},
	evaluator_admin: {
		en: "Admin",
		ar: "المشرف",
	},
	evaluate_your_property: {
		en: "Tap To Register For Valuation",
		ar: "اضغط لتثمين العقارات الخاصة بك",
	},
	select_login_type: {
		en: "Please select a Login type",
		ar: "يرجى تحديد نوع تسجيل الدخول",
	},
	registered_mobile_number: {
		en: "Mobile No. (Registered in Trakheesi System)",
		ar: "رقم الهاتف المتحرك (مسجل في نظام  تراخيصي)",
	},
	next: {
		en: "Next",
		ar: "التالي",
	},
	invalid_mobile: {
		en: "Invalid mobile number",
		ar: "رقم الهاتف الجوال غير صحيح",
	},
	invalid_otp: {
		en: "Invalid OTP",
		ar: "الرقم السري غير صحيح",
	},
	otp_message: {
		en: "The OTP has been sent to you on mobile number",
		ar: "لقد تم إرسال رمز التحقق على رقم الهاتف المحمول",
	},
	enter_otp: {
		en: "Enter OTP Code",
		ar: "أدخل رمز التحقق",
	},
	did_not_receive: {
		en: "Didn't receive the OTP?",
		ar: "لم تحصل على رمز التحقق؟",
	},
	resend_code: {
		en: "Resend OTP",
		ar: "إعادة الإرسال",
	},
	dashboard: {
		en: "Dashboard",
		ar: "لوحة القيادة",
	},
	search_for_valuation_requests: {
		en: "Search for Valuation Requests",
		ar: "البحث عن طلبات التقييم",
	},
	zone: {
		en: "Zone",
		ar: "الجهة",
	},
	community: {
		en: "Community",
		ar: "الموقع",
	},
	municipality_number: {
		en: "Municipality No.",
		ar: "رقم الأرض (بلدية دبي)",
	},
	building_number: {
		en: "Building No.",
		ar: "رقم المبنى",
	},
	building_name: {
		en: "Building Name",
		ar: "اسم المبنى",
	},
	unit_number: {
		en: "Unit No.",
		ar: "رقم الوحدة",
	},
	unit_number_full: {
		en: "Unit Number",
		ar: "رقم الوحدة",
	},
	land_status: {
		en: "Land Status",
		ar: "حالة الأرض",
	},
	valuation_reason: {
		en: "Valuation Reason",
		ar: "سبب التقييم",
	},
	valuation_company_ev: {
		en: "Valuation Company",
		ar: "شركة التقييم",
	},
	assign: {
		en: "Assign",
		ar: "تعيين",
	},
	accept: {
		en: "Accept",
		ar: "قبول",
	},
	reject: {
		en: "Reject",
		ar: "رفض",
	},
	submit: {
		en: "Submit",
		ar: "تقديم",
	},
	confirm_logout: {
		en: "Are you sure you want to logout ?",
		ar: "هل أنت متأكد من تسجيل الخروج ؟",
	},
	yes: {
		en: "Yes",
		ar: "نعم",
	},
	no: {
		en: "No",
		ar: "لا",
	},
	ok: {
		en: "Ok",
		ar: "موافق",
	},
	evaluation_form: {
		en: "Valuation Form",
		ar: "موافق",
	},
	terms_conditions: {
		en: "I confirm that the information given in this form is true, complete and accurate",
		ar: "أتعهد بصحة البيانات المدخلة في النظام",
	},
	owner_approve_terms_conditions: {
		en: "I confirm that the owner's consent is available for this request.",
		ar: "أؤكد على ان موافقة المالك متاحة لهذا الطلب",
	},
	note: {
		en: "Note: ",
		ar: "ملحوظة: ",
	},
	owner_information_share: {
		en: "The details of this request will be shared with the owners as an information",
		ar: "سيتم مشاركة تفاصيل طلب التقييم مع الملاك.",
	},
	accept_terms_conditions: {
		en: "Please accept terms and conditions.",
		ar: "يرجى قبول الشروط والأحكام.",
	},
	search_property: {
		en: "Search Property",
		ar: "بحث عقار",
	},
	property_type: {
		en: "Property Type",
		ar: "نوع العقار",
	},
	unit: {
		en: "Unit",
		ar: "وحدة سكنية",
	},
	villa: {
		en: "Villa",
		ar: "فيلا",
	},
	villa_name: {
		en: "Villa Name",
		ar: "اسم فيلا",
	},
	search_result: {
		en: "Search Result",
		ar: "نتائج البحث",
	},
	unit_type: {
		en: "Unit Type",
		ar: "نوع الشقة",
	},
	valuation_submit_success: {
		en: "Your valuation request ~ has been submitted successfully.",
		ar: "لقد تم تقديم طلب التقييم ~  بنجاح.",
	},
	back_to_home: {
		en: "Back to Home",
		ar: "العودة إلى الصفحة الرئيسية",
	},
	evaluate_property: {
		en: "Valuate Property",
		ar: "تقييم العقارات",
	},
	my_requests: {
		en: "My Requests",
		ar: "طلباتي",
	},
	owners_requests: {
		en: "Owners Requests",
		ar: "طلبات الملاك",
	},
	submitted: {
		en: "Submitted",
		ar: "مقدم",
	},
	all_requests: {
		en: "All Requests",
		ar: "جميع الطلبات",
	},
	new: {
		en: "New",
		ar: "جديد",
	},
	issued: {
		en: "Issued",
		ar: "أصدرت",
	},
	assigned: {
		en: "Assigned",
		ar: "تعيين",
	},
	assigned_myself: {
		en: "Assigned to Me",
		ar: "معينة لي",
	},
	rejected: {
		en: "Rejected",
		ar: "مرفوض",
	},
	land: {
		en: "Land",
		ar: "أرض",
	},
	building: {
		en: "Building",
		ar: "بناية",
	},
	eid: {
		en: "Emirates ID",
		ar: "رقم الهوية الإماراتية",
	},
	owner_name: {
		en: "Owner Name",
		ar: "اسم المالك حسب شهادة الملكية",
	},
	owner_cert_num: {
		en: "Title Deed Certificate No.",
		ar: "رقم شهادة الملكية",
	},
	owner_cert_year: {
		en: "Title Deed Certificate Year",
		ar: "تاريخ اصدار الملكية",
	},
	attach_attorney_letter: {
		en: "Attach Power of Attorney Documents",
		ar: "إرفاق نسخة من التوكيل القانوني",
	},
	attorney_letter: {
		en: "Power of Attorney Letter",
		ar: "خطاب التوكيل",
	},
	letter_exp_date: {
		en: "Power of Attorney Expiration Date",
		ar: "تاريخ انتهاء صلاحية الوكالة",
	},
	select_document: {
		en: "Select Document",
		ar: "اختر الوثيقة",
	},
	upload_pdf: {
		en: "Upload PDF",
		ar: "تحميل Pdf",
	},
	land_number: {
		en: "Land No. (DLD)",
		ar: "رقم الأرض (دائرة الأراضي)",
	},
	total_units: {
		en: "Total Units",
		ar: "مجموع وحدات",
	},
	type: {
		en: "Type",
		ar: "النوع",
	},
	land_type: {
		en: "Land Type",
		ar: "نوع الأرض",
	},
	area_size_sq_mt: {
		en: "Area Size (Sq.Mt)",
		ar: "المساحة (متر مربع)",
	},
	area_size_sq_ft: {
		en: "Area Size (Sq.Ft)",
		ar: "المساحة (قدم مربع)",
	},
	rejection_reason: {
		en: "Rejection Reason",
		ar: "سبب الرفض",
	},
	confirm: {
		en: "Confirm",
		ar: "تأكيد",
	},
	assign_evaluator: {
		en: "Assign Valuator",
		ar: "تعيين المقيم",
	},
	sq_mt_worth: {
		en: "Sq.Mt Worth",
		ar: "سعر المتر",
	},
	sq_ft_worth: {
		en: "Sq.Ft Worth",
		ar: "سعر القدم",
	},
	total_property_worth: {
		en: "Total Property Worth",
		ar: "القيمة الكلية",
	},
	date_of_valuation: {
		en: "Date Of Valuation",
		ar: "تاريخ التقييم",
	},
	notes: {
		en: "Notes",
		ar: "ملاحظات",
	},
	complete_valuation: {
		en: "Complete Valuation",
		ar: "إكتمال التقييم",
	},
	update_valuation: {
		en: "Update Valuation",
		ar: "تحديث التقييم",
	},
	valuation_based: {
		en: "Valuation Based",
		ar: "التقييم على أساس",
	},
	sq_mt: {
		en: "Sq.Mt",
		ar: "متر مربع",
	},
	sq_ft: {
		en: "Sq.Ft",
		ar: "قدم مربع",
	},
	aed: {
		en: "AED",
		ar: "درهم",
	},
	issue_certificate: {
		en: "Issue Certificate",
		ar: "إصدار الشهادة",
	},
	view_certificate: {
		en: "View Certificate",
		ar: "عرض الشهادة",
	},
	no_pdf_viewer: {
		en: "Please install PDF viewer to see the certificate.",
		ar: "برجاء تثبيت تطبيق بى دى اف لرؤية الشهادة",
	},
	english: {
		en: "English",
		ar: "English",
	},
	arabic: {
		en: "العربية",
		ar: "العربية",
	},
	select_language: {
		en: "Select Language",
		ar: "اختار اللغة",
	},
	logout: {
		en: "Logout",
		ar: "خروج",
	},
	login: {
		en: "Login",
		ar: "تسجيل الدخول",
	},
	sign_out: {
		en: "Sign Out",
		ar: "خروج",
	},
	contact_us: {
		en: "Contact Us",
		ar: "للتواصل معنا",
	},
	dubailand_address: {
		en: "Dubai Land Department \n Dubai - Deira Baniyas Road, P.O.Box 1166 \n United Arab Emirates",
		ar: "دائرة الأراضي والأملاك \n دبي - ديرة شارع بني ياس ، ص ب 1166  \nالإمارات العربية المتحدة",
	},
	view_map: {
		en: "View Map",
		ar: "عرض الخريطة",
	},
	makaan_no: {
		en: "Makaani No.",
		ar: "رقم مكاني",
	},
	call: {
		en: "Call",
		ar: "مكالمة هاتفية",
	},
	email: {
		en: "Email",
		ar: "البريد",
	},
	fax: {
		en: "Fax",
		ar: "فاكس",
	},
	privacy_policy: {
		en: "Privacy Policy",
		ar: "سياسة الخصوصية",
	},
	our_commitment: {
		en: "Our Commitment",
		ar: "التزامنا",
	},
	privacy_policy_text: {
		en: "Dubai Government is committed to respecting your privacy and protecting your personal information. We recognize our obligation to keep sensitive information secure and have created this privacy and security statement to share and explain the current information management practices on our websites. ",
		ar: "",
	},
	open_source_license: {
		en: "Open Source License",
		ar: "رخصة مفتوحة المصدر",
	},
	open_source_license_text: {
		en: "Dubai Government is committed to respecting your privacy and protecting your personal information. We recognize our obligation to keep sensitive information secure and have created this privacy and security statement to share and explain the current information management practices on our websites. ",
		ar: "",
	},
	dld_email: {
		en: "info@dubailand.gov.ae",
		ar: "info@dubailand.gov.ae",
	},
	dld_phone: {
		en: "+971 8004488",
		ar: "+971 8004488",
	},
	dld_makani: {
		en: "30404 94991",
		ar: "30404 94991",
	},
	dld_fax: {
		en: "+971 42222251",
		ar: "+971 42222251",
	},
	edit: {
		en: "Edit",
		ar: "تحرير",
	},
	settings: {
		en: "Settings",
		ar: "إعدادت",
	},
	settings_access: {
		en: "Application setting changes option",
		ar: "خيار تغيير إعدادات التطبيق",
	},
	confirm_assign: {
		en: "Are you sure you want to assign this request ?",
		ar: "هل أنت متأكد من أنك تريد تعيين هذا الطلب؟",
	},
	confirm_complete: {
		en: "Are you sure you want to complete this request ?",
		ar: "هل أنت متأكد من أنك تريد إكمال هذا الطلب؟",
	},
	confirm_update: {
		en: "Are you sure you want to update this valuation ?",
		ar: "هل أنت متأكد من أنك تريد تحديث هذا التقييم؟",
	},
	checking_for_updates: {
		en: "Checking for Updates",
		ar: "التحقق من التحديثات",
	},
	downloading_updates: {
		en: "Downloading Updates",
		ar: "تحميل التحديثات",
	},
	installing_updates: {
		en: "Installing Updates",
		ar: "تثبيت التحديثات",
	},
	restarting: {
		en: "Restarting",
		ar: "اعادة التشغيل",
	},
	name: {
		en: "Name",
		ar: "الإسم",
	},
	requester_details: {
		en: "Requester Details",
		ar: "تفاصيل مقدم الطلب",
	},
	evaluation_request_details: {
		en: "Valuation Request Details",
		ar: "تفاصيل طلب التقييم",
	},
	evaluation_details: {
		en: "Valuation Details",
		ar: "تفاصيل التقييم",
	},
	evaluator_card_number: {
		en: "Valuator Card No.",
		ar: "رقم بطاقة المقيم",
	},
	requester_type: {
		en: "Requester Type",
		ar: "مقدم الطلب",
	},
	pending_issuing_certificate: {
		en: "Pending Issuing Certificate",
		ar: "بانتظار إصدار الشهادة",
	},
	confirm_issue_certificate: {
		en: "Are you sure you want to issue the certificate for this request ?",
		ar: "هل أنت متأكد من أنك تريد إصدار الشهادة لهذا الطلب ؟",
	},
	terms_conditions_certificate: {
		en: "Kindly confirm that all processes related to this valuation have been completed.",
		ar: "يرجى التأكد من اكتمال جميع العمليات المتعلقة بهذا التقييم.",
	},
	address: {
		en: "Address",
		ar: "العنوان",
	},
	company_details: {
		en: "Company Details",
		ar: "تفاصيل الشركة",
	},
	req_source: {
		en: "Request Source",
		ar: "مصدر الطلب",
	},
	valuation_scope: {
		en: "Valuation Scope",
		ar: "نطاق التقييم",
	},
	happiness_meter: {
		en: "Happiness Meter",
		ar: "مقياس السعادة",
	},
	select: {
		en: "Select",
		ar: "اختر",
	},
	valuators: {
		en: "Valuators",
		ar: "مقيم",
	},
	done: {
		en: "Done",
		ar: "فعله",
	},
	all: {
		en: "All",
		ar: "الكل",
	},
	reset: {
		en: "Reset",
		ar: "إعادة تعيين",
	},
	empty_land_confirm: {
		en: "Is it an Empty Land ?",
		ar: "هل الأرض فارغة؟",
	},
	for_client_use: {
		en: "For Client Use",
		ar: "لاستخدام العميل",
	},
	for_office_use: {
		en: "For Office Use",
		ar: "لاستخدام المكتب",
	},
	registered_in_trakheesi: {
		en: "Registered in Trakheesi System",
		ar: "مسجل في نظام  تراخيصي",
	},
	valuator_number: {
		en: "Valuator No. : ",
		ar: "رقم المقيم :",
	},
	under_processing: {
		en: "Under Processing",
		ar: "قيد العمل",
	},
	request_status: {
		en: "Request Status",
		ar: "حالة الطلب",
	},
	search_for_property: {
		en: "Search For Property",
		ar: "البحث عن عقار",
	},
	search_for_specific_property: {
		en: "Search For Specific Property",
		ar: "البحث عن عقار معين",
	},
	completed_owner: {
		en: "Completed",
		ar: "منجز",
	},
	company_login_info: {
		en: "To be able to use this application, you must have active valuation card and an admin user configured in Trakheesi system.\n\nIf need any assistance, please contact support@dubailand.gov.ae",
		ar: "لتكون قادرًا على استخدام هذا التطبيق ، يجب أن يكون لديك بطاقة تقييم فعالة ومستخدم مسؤول مسجل في نظام تراخيصي.\n\nإذا احتجت إلى أي مساعدة ، يرجى الاتصال بـ support@dubailand.gov.ae",
	},
	home: {
		en: "Home",
		ar: "الصفحة الرئيسية",
	},
	certificate: {
		en: "Certificate",
		ar: "شهادة",
	},
	verify_certificate: {
		en: "Verify Valuation Certificate",
		ar: "التحقق من شهادة التقييم",
	},
	certificate_number: {
		en: "Certificate No.",
		ar: "رقم الشهادة",
	},
	certificate_person_detail: {
		en: "Owner Participant No. / Name",
		ar: "رقم / اسم المالك المشارك",
	},
	back: {
		en: "Back",
		ar: "الى الخلف",
	},
	status: {
		en: "Status",
		ar: "الحالة",
	},
	issue_date: {
		en: "Issue Date",
		ar: "تاريخ الاصدار",
	},
	expiry_date: {
		en: "Expiry Date",
		ar: "تاريخ الانتهاء",
	},
	plot_number: {
		en: "Plot No.",
		ar: "رقم القطعة",
	},
	dubai: {
		en: "Dubai",
		ar: "دبي",
	},
	valid: {
		en: "Valid",
		ar: "صالح",
	},
	size: {
		en: "Size",
		ar: "المساحة",
	},
	certificate_valid: {
		en: "Certificate is Valid",
		ar: "الشهادة صالحة",
	},
	valuator_name: {
		en: "Valuator Name",
		ar: "اسم التقييم",
	},
	card_expiring: {
		en: "Card Exp. :",
		ar: "هاتف المتحرك :",
	},
	total_property_worth_words: {
		en: "Total Property Worth (Words)",
		ar: "القيمة الكلية",
	},
	request: {
		en: "Request",
		ar: "طلب",
	},
	third_party_valuation: {
		en: "External Valuation",
		ar: "تقييمي",
	},
	search_by: {
		en: "Search By",
		ar: "البحث عن طريق",
	},
	title_deed: {
		en: "Title Deed",
		ar: "شهادة ملكية عقار",
	},
	off_plan: {
		en: "Off Plan",
		ar: "عقد بيع مبدئى",
	},
	no_building_found: {
		en: "No Building Found",
		ar: "لم يتم إيجاد المبنى",
	},
	build_up_area_sq_mt: {
		en: "Build Up Area (Sq.Mt)",
		ar: "المساحة المبنية (متر.مربع)",
	},
	build_up_area_sq_ft: {
		en: "Build Up Area (Sq.Ft)",
		ar: "المساحة المبنية (قدم.مربع)",
	},
	valuation_date_check: {
		en: "Valuation date, cannot be a future date.",
		ar: "تاريخ التقييم ، لا يمكن أن يكون تاريخًا في المستقبل.",
	},
	select_valuation_company: {
		en: "Please select a valuation company",
		ar: "الرجاء اختيار شركة التقييم",
	},
	ranking_details: {
		en: "Ranking Details",
		ar: "تفاصيل التصنيف",
	},
	classification_office: {
		en: "Office Classification",
		ar: "تصنيف المكتب",
	},
	standard: {
		en: "Standard",
		ar: "قياسي",
	},
	points: {
		en: "Points",
		ar: "النقاط",
	},
	total_points_ev: {
		en: "Total Points : ",
		ar: "مجمل النقاط : ",
	},
	broker_number: {
		en: "Broker Number",
		ar: "رقم الوسيط",
	},
	valuer_number: {
		en: "Valuer Number",
		ar: "رقم المثمن",
	},
	classification_details: {
		en: "Classification Details",
		ar: "تفاصيل التصنيف",
	},
	classification_broker: {
		en: "Broker Classification",
		ar: "تصنيف الوسيط",
	},
	classification_valuer: {
		en: "Valuer Classification",
		ar: "تصنيف المثمن",
	},
	employee_details: {
		en: "Employee Details",
		ar: "تفاصيل الموظف",
	},
	search_valuation_request: {
		en: "Search Valuation Request",
		ar: "البحث عن طلب التقييم",
	},
	valuation_request_status: {
		en: "Valuation Request Status",
		ar: "حالة طلب التقييم",
	},
	clear_all_filters: {
		en: "Clear All Filters",
		ar: "مسح بيانات البحث",
	},
	participant_number: {
		en: "Participant Number",
		ar: "رقم المشارك",
	},
	title_deed_details: {
		en: "Title Deed Details",
		ar: "تفاصيل شهادة الملكية",
	},
	understand_title_deed: {
		en: "Know your Title Deed",
		ar: "اعرف شهادة الملكية الخاص بك",
	},
	external_valuation: {
		en: "External Valuation",
		ar: "تقييمي",
	},
	view_details: {
		en: "View Details",
		ar: "عرض التفاصيل",
	},
	view_ranking_details: {
		en: "View Ranking Details",
		ar: "عرض تفاصيل التصنيف"
	},
	license_no: {
		en: "License Number :",
		ar: "رقم الرخصة التجارية : "
	}
};
